import { Component, Inject } from '@angular/core';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SharedModule } from 'src/app/shared/shared.module';
import { DeleteItemComponent } from '../../delete-item/delete-item.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: true,
  selector: 'app-view-contract-document',
  imports: [  PdfViewerModule, SharedModule,],
  templateUrl: './view-contract-document.component.html',
  styleUrls: ['./view-contract-document.component.scss']
})
export class ViewContractDocumentComponent {
  serverFileName!:string;
  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: any,public dialogRef: MatDialogRef<DeleteItemComponent>,){}
  ngOnInit(){
    if(this.dialogData){
      this.serverFileName=this.dialogData
    }
  }
}
